<template>
  <Grid>
    <template v-if="hasPaymentConfig || editPaymentInfo || isStationInitialSetup">
      <Col6><Type /></Col6>

      <Col6></Col6>

      <!-- Vshow requires html components due to its nature -->
      <div class="col-12" v-show="isFreedomPay">
        <Grid>
          <Col6><StoreID /></Col6>

          <Col6><TerminalID /></Col6>
        </Grid>
      </div>

      <!-- Remove payment settings button positioned at bottom left -->
      <Col12 v-if="!isSiteConfig && hasPaymentConfig && editPaymentInfo">
        <div class="flex justify-content-start">
          <RemovePaymentSettings />
        </div>
      </Col12>
    </template>

    <template v-else-if="!editPaymentInfo">
      <Col12>
        {{ translate(`${LOCALE_PREFIX}.empty`) }}
      </Col12>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { usePaymentInfo } from '../composables';
import { Grid } from '@centric-os/components/src/core/layouts/grids/grid';
import { Col6 } from '@centric-os/components/src/core/layouts/columns/col-6';
import { Col12 } from '@centric-os/components/src/core/layouts/columns/col-12';
import { useFieldValue } from 'vee-validate';
import { computed, onMounted } from 'vue';

// Define props
const props = defineProps({
  isSiteConfig: {
    type: Boolean,
    required: false,
  },
});
import Type from '../fields/type/Type.vue';
import StoreID from '../fields/freedom-pay/store-id/StoreID.vue';
import TerminalID from '../fields/freedom-pay/terminal-id/TerminalID.vue';
import RemovePaymentSettings from '../actions/remove-payment-settings/RemovePaymentSettings.vue';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../enums';
import { useFinancialConfigStore } from '../../../../../routes';
import { FREEDOM_PAY_CONFIG_TYPES } from '../../enums';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { CustomPermissions } from '@centric-os/types';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;
// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

// Set auth store
const authStore = useAuthStore();

const typeFieldName = computed(() => {
  return isStationInitialSetup.value ? 'paymentConfig.paymentSettings.type' : 'type';
});
// Set payment config type field value
const type = useFieldValue<string>(typeFieldName.value);

// Set payment config composable
const { hasPaymentConfig } = usePaymentInfo();

// Check if type is FreedomPay
const isFreedomPay = computed<boolean>(() => FREEDOM_PAY_CONFIG_TYPES.includes(type.value));

onMounted(() => {
  if (
    isStationInitialSetup.value &&
    !hasPaymentConfig.value &&
    authStore.hasPermissions([CustomPermissions.viewPaymentInfo])
  ) {
    editPaymentInfo.value = true;
  }
});
</script>
